import { hexToHSL } from "@/assets/js/mcn-helpers";
export default {
  name: "MainSectionSVG",
  props: {
    data: Object
  },
  computed: {
    primary() {
      var _this$data$primaryCol, _this$data;
      return (_this$data$primaryCol = (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.primaryColor) !== null && _this$data$primaryCol !== void 0 ? _this$data$primaryCol : '#407BFB';
    },
    secondary() {
      var _this$data$secondaryC, _this$data2;
      return (_this$data$secondaryC = (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.secondaryColor) !== null && _this$data$secondaryC !== void 0 ? _this$data$secondaryC : '#407BFB';
    },
    sacOutlined() {
      return this.secondaryLighter();
    },
    phoneButtonLeft() {
      return this.primary;
    },
    phoneButtonRight() {
      return this.primary;
    },
    phoneTopLine() {
      return this.primary;
    }
  },
  methods: {
    secondaryLighter(times = 1) {
      var _hexToHSL;
      let hsla = (_hexToHSL = hexToHSL(this.secondary)) !== null && _hexToHSL !== void 0 ? _hexToHSL : {};
      hsla.l += times * (1 - hsla.l) / 6;
      return this.convertHslaObjectToString(hsla);
    },
    convertHslaObjectToString(hsla) {
      return `hsla(${hsla.h * 360}, ${hsla.s * 100}%, ${hsla.l * 100}%, 1)`;
    }
  }
};